/**
 * Botões de teste: preencher a ativação com dados de teste, pagar com o
 * cartão de teste, pular a escolha de plano e o onboarding.
 *
 * Só a flag decide (não `__DEV__`): liga com `EXPO_PUBLIC_TEST_TOOLS=true`
 * no build do staging (secret do environment `staging` no GitHub) e no
 * `.env.local` de quem desenvolve. Nunca em produção.
 */
export const TEST_TOOLS_ENABLED = process.env.EXPO_PUBLIC_TEST_TOOLS === 'true';
